<template>
  <b-container class="card-container">
    <b-card no-body>
      <template v-slot:header>
        <b-row>
          <b-col>
            <b-form-select v-if="profile.role == 'admin'" :options="avatars_options" v-model="filter_avatar" class="mr-2" size='sm' style='max-width: 200px' @change="search"/>
          </b-col>
          <b-col>
            <b-button size="sm" variant="primary float-right" :to="{name: `${collection}_create`}">Create</b-button>
          </b-col>
        </b-row>

      </template>

      <b-table show-empty ref="table" :items="items" @row-clicked="view_row" hover class="clickable" :fields="fields">
        <template v-slot:cell(updated)='data'>
          {{data.value | date}}
        </template>
        <template v-slot:cell(status)='data'>
          <b-badge :class='`status-${data.value}`'>{{data.value}}</b-badge>
        </template>
        <template v-slot:cell(created)='data'>
          {{data.value | date}}
        </template>
        <template v-slot:cell(clone)='data'>
          <!-- {{data.item.voice_doc.id}} -->
          <b-link :to="{name: 'voice', params: {id: data.item.voice_doc.id}}" v-if='data.item.clone_name'>{{data.item.clone_name}}</b-link>
        </template>
        <!-- <template v-slot:cell(name)='data'>
          <b-link :to="{name: collection, params: {id: data.item.id}}">{{data.value}}</b-link>
        </template> -->
      </b-table>

      <template v-slot:footer>
        <b-form inline>
          <b-button-toolbar>
            <b-button-group size="sm">
              <LoadingButton size="sm" @click="search('previous_page')" :disabled="current_page == 0" :loading="previous_page_loading">&lsaquo; Last</LoadingButton>
            </b-button-group>
            <b-button-group class="ml-2" size="sm">
              <LoadingButton size="sm" @click="search('next_page')" :disabled="items.length != page_size || no_more_results" :loading="next_page_loading">Next &rsaquo;</LoadingButton>
            </b-button-group>
          </b-button-toolbar>

          <b-form-select :options="page_size_options" v-model="page_size" @change="search" size="sm" class='ml-2'></b-form-select>
        </b-form>

      </template>
    </b-card>
  </b-container>
</template>

<script>

import { db } from '@/main.js'
import ItemMixin from '@/mixins/Item.js'
import constants from '@/lib/constants.js'

export default {
  name: 'project_list',
  metaInfo: {title: 'Videos'},
  mixins: [ItemMixin],
  data() {
    let fields = ['name', 'clone', {label: 'Videos', key: 'items_count'}, 'created', 'updated']

    if (this.profile.role === 'admin') {
      fields.splice(1, 0, 'status')
    }

    return {
      avatars: [],
      collection: 'project',
      filter_avatar: null,
      fields: fields
    }
  },
  computed: {
    avatars_options() {
      let avatars_options = [{value: null, text: 'All clones'}]
      for (let avatar of this.avatars) {
        if (!avatar.id) {
          break
        }
        avatars_options.push({value: db.collection('voice').doc(avatar.id), text: avatar.name})
      }

      return avatars_options
    },
  },
  created() {
    let avatars = db.collection('voice').where('user', '==', db.collection('user').doc(this.profile.id))
    if (this.profile.team_role.role === constants.team_role.admin || this.profile.team_role.role === constants.team_role.manager) {
      avatars = db.collection('voice').where('team', '==', db.collection('team').doc(this.profile.team.id))
    }

    if (this.profile.role === 'admin') {
      avatars = db.collection('voice')
    }

    this.$bind('avatars', avatars.where('status', '==', 'complete').orderBy('created', 'desc'), {maxRefDepth: 0})

    this.search()
  },
  activated () {
    this.search()
  },
  methods: {
    async search(action) {
      this.loading = true

      let query = db.collection(this.collection).where('user', '==', db.collection('user').doc(this.profile.id))
      if (this.profile.team_role.role === constants.team_role.admin || this.profile.team_role.role === constants.team_role.manager) {
        query = db.collection(this.collection).where('team', '==', db.collection('team').doc(this.profile.team.id))
      }

      if (this.profile.role === 'admin') {
        query = db.collection(this.collection)
      }

      query = query.orderBy('created', 'desc')

      if (action == 'next_page') {
        this.next_page_loading = true
        let last_item = this.items[this.items.length-1]
        query = query.startAfter(last_item.doc).limit(this.page_size)
        this.current_page++
      } else if (action == 'previous_page') {
        this.previous_page_loading = true
        let first_item = this.items[0]
        query = query.endBefore(first_item.doc).limitToLast(this.page_size)
        this.current_page--
      } else {
        query = query.limit(this.page_size)
        this.current_page = 0
      }

      query = query.where('status', 'in', ['pending', 'processing', 'complete', 'error'])

      if (this.filter_avatar) {
        query = query.where('voice_doc', '==', this.filter_avatar)
      }

      let clones = {}
      for (let avatar of this.avatars || []) {
        clones[avatar.id] = avatar
      }

      let docs = await query.get()
      if (docs.docs.length > 0 || action != 'next_page') {
        this.no_more_results = false
        let items = []
        for (let doc of docs.docs) {
          let item = doc.data()

          if (!item.voice_doc) {
            console.error('No voice doc', item, item.id)
            continue
          }

          if (item.voice_doc && !clones[item.voice_doc.id]) {
            let clone_doc = await doc.data().voice_doc.get()
            clones[item.voice_doc.id] = clone_doc.data()
            clones[item.voice_doc.id].id = clone_doc.id
          }

          if (item.voice_doc && clones[item.voice_doc.id]) {
            item.clone_name = clones[item.voice_doc.id].name
          } else {
            item.clone_name = ''
          }

          item.id = doc.id
          item.doc = doc
          items.push(item)
        }

        this.items = items
      } else {
        this.no_more_results = true
        this.current_page--
      }

      if (this.items.length > 0) {
        if (action != 'previous_page') {
          // Peak ahead
          let docs = await query.startAfter(this.items[this.items.length-1].doc).limit(1).get()
          if (docs.docs.length === 0) {
            this.no_more_results = true
          } else {
            this.no_more_results = false
          }
        }
      }

      this.next_page_loading = false
      this.previous_page_loading = false
      this.loading = false
    },
  },
}
</script>

<style scoped>

</style>
